import { render, staticRenderFns } from "./FileDelete.vue?vue&type=template&id=4d29ae1c&scoped=true&"
import script from "./FileDelete.vue?vue&type=script&lang=js&"
export * from "./FileDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29ae1c",
  null
  
)

export default component.exports